module.exports = __webpack_public_path__ + "img/homeIcon.cc56c858.png";